import {defineStore, type StoreDefinition} from 'pinia';
import {state, type UserStoreState} from './state';
import {type UserStoreActions, actions} from './actions';
import {getters, type UserStoreGetters} from './getters';

export type UserStoreType = StoreDefinition<string, UserStoreState, UserStoreGetters, UserStoreActions>;

export const useUserStore: UserStoreType = defineStore('userStore', {
    state,
    getters,
    actions
});
